module.exports={
  "SITE_NAME": "Designstipendiet",
  "SITE_DESCRIPTION": "Din framtid kan bÃ¶rja pÃ¥ Beckmans KvÃ¤llsskola! Familjen Robert Weils Stiftelse har startat Designstipendiet. Om du vill sÃ¶ka kvÃ¤llsskolan men tvekar infÃ¶r att den kostar pengar Ã¤r du en av de som har mÃ¶jlighet att ansÃ¶ka om Designstipendiet. Stipendiet tÃ¤cker kostnaden fÃ¶r utbildningen.",
  "Question %s of %s": "Question %s of %s",
  "Cancel": "Cancel",
  "Previous question": "Previous question",
  "Next question": "Next question"
}
